import styled, { css } from 'styled-components';
import BaseIcon from '../Icon/Icon';
import { SelectStyledProps } from '../Select/Select.typed';

export const Wrapper = styled.div`
  position: relative;
`;

export const Icon = styled(BaseIcon)`
  position: absolute;
  top: 12px;
  right: 12px;
  color: ${({ theme }) => theme.brand.primary.base};
  pointer-events: none;
`;

// TODO use theme values
export const Select = styled.select<SelectStyledProps>`
  display: block;
  width: 100%;
  height: 40px;
  padding: 8px 40px 8px 16px;
  font-size: 16px;
  line-height: 24px;
  appearance: none;
  background: #ffffff;
  border: 1px solid #999;
  border-radius: 4px;
  color: #333;
  cursor: pointer;

  :invalid {
    color: #999;
  }

  &:focus {
    border-color: ${({ theme }) => theme.brand.primary.base};
    outline: none;
  }

  &:disabled {
    background-color: #f2f2f2;
    border-color: #d9d9d9;
    color: #999;

    ~ ${Icon} {
      color: #999;
    }
  }

  ${({ hasError }) =>
    hasError &&
    css`
      &,
      &:focus,
      &:invalid {
        color: #cc2324;
        border-color: #cc2324;

        ~ ${Icon} {
          color: #cc2324;
        }
      }
    `}
`;
